module.exports = __webpack_public_path__ + "img/00—01—Login—IB2 > Notification > Confirmation.8f164581.jpg";